import PaymentHistory from "@/views/admin/payments/PaymentHistory";

export default {
  path: "orders/payment-history",
  name: "paymentHistory",
  component: PaymentHistory,
  meta: {
    requiresAuth: true
  }
};
